const bootstrap = require('bootstrap');

/**
 * Set image, reset to default and show "Add to my favourites" modal.
 * @param {Node} modal_el - "Add to my favourites" modal node
 * @param {string} inspiration_id - ID of shown inspiration
 * @param {string} inspiration_image_url - image to be shown in modal
 * @param {string} default_folder_image - default image for dropdown
 * @return {boolean} - True if modal was shown, False if it doesn't exist (which we assume means user is logged out)
 */
const show_add_inspiration_to_favourites_modal = (modal_el, inspiration_id, inspiration_image_url, default_folder_image) => {
    if (!modal_el) {
        return false;
    }

    // region Reset modal
    modal_el
        .querySelector('input[name=inspiration_id]')
        .value = inspiration_id;

    modal_el
        .querySelector('input[name=catalog_id]')
        .value = '';

    modal_el
        .querySelector('a.dropdown-toggle img')
        .setAttribute('src', default_folder_image);

    modal_el
        .querySelector('textarea[name=description]')
        .value = '';

    modal_el
        .querySelector('.inspiration-img img')
        .setAttribute('src', inspiration_image_url);

    modal_el
        .querySelector('.dropdown .catalog-feedback')
        .style.display = 'none';

    let catalog_name_span = modal_el
        .querySelector('span[name=catalog-name]');
    catalog_name_span.innerText = catalog_name_span.dataset.defaultText;
    // endregion Reset modal

    let modal = new bootstrap.Modal(modal_el, {});
    modal.show();

    return true;
};

const change_selected_folder = (modal_el, selected_folder, default_folder_image) => {
    modal_el
        .querySelector('.catalog-feedback')
        .style.display = 'none';
    modal_el
        .querySelector('input[name=catalog_id]')
        .value = selected_folder.dataset.catalogId;
    modal_el
        .querySelector('[name="catalog-name"]')
        .innerText = selected_folder.dataset.catalogName;

    const dropdown_toggle = modal_el.querySelector('.dropdown .dropdown-toggle');
    const folder_image_el = selected_folder.querySelector('img');

    dropdown_toggle
        .querySelector('img')
        .setAttribute(
            'src',
            folder_image_el ? folder_image_el.getAttribute('src') : default_folder_image
        );
};

/**
 *
 * @param {Element} modal_el
 * @param {Element} form
 */
const submit_add_inspiration_to_favourites_modal = (modal_el, form) => {
    let url = form.getAttribute('action')
    let catalog_id = form.querySelector('input[name=catalog_id]');
    let formData = new FormData(form);
    let csrf_token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

    if (catalog_id.value) {
        $.ajax({
            url: url,
            method: 'post',
            data: formData,
            processData: false,
            contentType: false,
            headers: {
                'X-CSRF-TOKEN': csrf_token,
                'Accept': 'application/json'
            }
        }).done((data) => {
            if (data.status !== 200) {
                let toast = new bootstrap.Toast(document.getElementById("add-inspiration-fail"));
                toast.show();
            } else {
                let toast = new bootstrap.Toast(document.getElementById("add-inspiration-success"));
                toast.show();

                // Update folder list
                const dropdown_element_to_update = modal_el.querySelector(`.dropdown [data-catalog-id="${catalog_id.value}"]`)
                const number_of_inspirations_translations = modal_el.querySelector('.translations-number-of-inspirations');
                if (dropdown_element_to_update && number_of_inspirations_translations) {
                    let number = (parseInt(dropdown_element_to_update.dataset.number) || 0) + 1;
                    dropdown_element_to_update.dataset.number = number;

                    const number_for_translation = number < 10 ? number : 10;
                    const translation_el = number_of_inspirations_translations.querySelector(`[data-translation-for-number="${number_for_translation}"]`)
                    const translation = (translation_el ? translation_el.dataset.translation : '${number}').replace('${number}', number);

                    const numbers_el = dropdown_element_to_update.querySelector('.numbers');
                    if (numbers_el) {
                        numbers_el.innerText = translation;
                    }
                }
            }

            bootstrap.Modal.getInstance(modal_el).hide();
        });
    } else {
        modal_el
            .querySelector('.catalog-feedback')
            .style.display = 'block';
    }
};

/**
 * Resets and shows "Create folder" modal.
 * @param {Node} modal_el - "Create folder" modal node
 * @returns {void}
 */
const show_create_folder_modal = (modal_el) => {
    // region Reset modal
    modal_el
        .querySelector('input[name=name]')
        .value = '';
    // endregion Reset modal

    let modal = new bootstrap.Modal(modal_el, {});
    modal.show();
};

/**
 * Creates a clone of dropdown item to be placed in folder list
 * @param {Object} item_data - AJAX result data, must have id and name attributes. Optional.
 * @return {Node} - new list item
 * @private
 */
const _new_folder_dropdown_item = (item_data) => {
    const template_catalog_item = document.querySelector('#modal-catalog-element').content;
    const item = template_catalog_item.querySelector('li').cloneNode(true);

    if (item_data) {
        let anchor = item.querySelector('a');
        anchor.dataset.catalogId = item_data.id;
        anchor.dataset.catalogName = item_data.name;

        item
            .querySelector('slot[name=catalog-name]')
            .innerText = item_data.name;
    }

    return item;
};

/**
 * Submits "create folder" over ajax and adds created folder to dropdown list in favourites modal.
 * @param {Node} modal_el - "Create folder" modal
 * @param parent_modal_el - "Add to favourites" modal
 * @param form - Form that was submitted
 * @returns {void}
 */
const submit_create_folder_modal = (modal_el, parent_modal_el, form) => {
    let url = form.getAttribute('action')
    let formData = new FormData(form);
    let csrf_token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

    $.ajax({
        url: url,
        data: formData,
        method: 'post',
        processData: false,
        contentType: false,
        headers: {
            'X-CSRF-TOKEN': csrf_token,
            'Accept': 'application/json'
        }
    })
        .done(function (result) {
            let new_item = _new_folder_dropdown_item(result.data);

            let create_folder_item = parent_modal_el
                .querySelector('.dropdown-menu .create-folder-item');
            create_folder_item.parentNode.insertBefore(new_item, create_folder_item);

            parent_modal_el
                .querySelector('input[name=catalog_id]')
                .value = result.data.id;

            parent_modal_el
                .querySelector('[name=catalog-name]')
                .innerText = result.data.name;

            bootstrap.Modal.getInstance(modal_el).hide();
        });
};

export {
    change_selected_folder,
    show_add_inspiration_to_favourites_modal,
    show_create_folder_modal,
    submit_add_inspiration_to_favourites_modal,
    submit_create_folder_modal,
};
